import {filter, unionBy} from 'lodash';
import fp from 'lodash/fp';
import req from 'shared/req';
import {PascalInstitutionType} from 'src/types/enums';

const subtextFields = ['address', 'city', 'state', 'country_code'];
const formatSchoolSubtext = fp.flow(fp.at(subtextFields), fp.compact, fp.join(', '));

const schoolResults = (query, queryResults, initialResults) => {
  const normalized = query.toLowerCase();
  const yourSchools = filter(
    initialResults,
    (result) => result.text.toLowerCase().indexOf(normalized) >= 0
  );

  const moreSchools = queryResults.map(({id, fields}) => ({
    ...fields,
    _id: id,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    text: fields.school_name,
    subtext: formatSchoolSubtext(fields),
    educationPhase: PascalInstitutionType.HIGH_SCHOOL,
  }));

  return unionBy(yourSchools, moreSchools, '_id');
};

const filterQueryTerm = (query) => (query || '').replace(/\./g, '');

export async function schoolQueryResults(query, initialResults = [], loc) {
  const data = {
    term: filterQueryTerm(query),
    size: 20,
  };

  if (loc) {
    data['lat'] = loc[0];
    data['long'] = loc[1];
  }

  return req({
    url: '/v1/high-schools',
    method: 'get',
    data,
  }).then((results) => schoolResults(query, results, initialResults));
}
